/* eslint-disable import/no-cycle */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import React, { useEffect, useState } from 'react';

import { DropdownSelector } from './DropdownSelector';
import { useStoreActions, useStoreState } from '../reducers';
import { TagCategory, Tag } from '../types';

/* 
TODO: vivian - 5/3/2024
  this tag control will be eventually deprecate when we update the table component.
  all filter dropdown will be updated at that time
  the current change is a patch, only remove the visual of tag category.
*/

const formatTags = (tags: Tag[]) => {
  const category: TagCategory = { id: 0, name: '' };
  const allTagsByCategory: Map<TagCategory, Tag[]> = new Map();

  tags.forEach((tag) => {
    const categoryTags = allTagsByCategory.get(category);

    if (!categoryTags) {
      allTagsByCategory.set(category, [tag]);
    } else {
      categoryTags.push(tag);
    }
  });

  allTagsByCategory.forEach((allTags) => {
    allTags.sort((a, b) => a.name.localeCompare(b.name));
  });

  return allTagsByCategory;
};

type TagControlsProps = {
  onChange: (newTags: string[]) => void;
  selectedTags: string[];
  placeholder?: string;
  height?: string;
  vertical?: boolean;
  setInputHandle?: (input: HTMLInputElement) => void;
  onInputFocusChange?: (isFocused: boolean) => void;
  subsetTagsToChooseFrom?: string[];
  showListInPopup?: boolean;
  disabled?: boolean;
  orgId?: number;
};

const subsetTagsByCategory = (
  allTagsByCategory: Map<TagCategory, Tag[]>,
  subset?: string[]
) => {
  if (!subset) {
    return allTagsByCategory;
  }

  const rs = new Map<TagCategory, Tag[]>();
  // eslint-disable-next-line no-restricted-syntax
  for (const [category, tags] of allTagsByCategory.entries()) {
    const subsetTags = tags.filter((tag) => subset.includes(tag.name));
    rs.set(category, subsetTags);
  }
  return rs;
};

const TagControls: React.FC<TagControlsProps> = ({
  selectedTags,
  onChange,
  placeholder,
  height,
  vertical = false,
  onInputFocusChange,
  setInputHandle = () => {},
  subsetTagsToChooseFrom,
  showListInPopup,
  disabled,
  orgId,
}) => {
  const [areTagsLoaded, setAreTagsLoaded] = useState(false);

  const { tags } = useStoreState((storeState) => ({
    ...storeState.recordingTag,
  }));
  const { fetchTags } = useStoreActions((actions) => actions.recordingTag);
  useEffect(() => {
    async function loadTags() {
      if (!orgId) return;
      try {
        await fetchTags(orgId);
        setAreTagsLoaded(true);
      } catch (error) {
        console.error(error, '-- tag control in filter');
      }
    }
    loadTags();
  }, [orgId, fetchTags]);

  // Load tags and tag categories on first render

  return (
    <DropdownSelector
      options={
        areTagsLoaded
          ? subsetTagsByCategory(formatTags(tags), subsetTagsToChooseFrom)
          : new Map()
      }
      selectedItems={selectedTags.sort()}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onSelectionChange={(newSelection) => {
        onChange(newSelection);
      }}
      placeholder={placeholder || 'Add Tags'}
      setInputHandle={setInputHandle}
      vertical={vertical}
      height={height}
      showListInPopup={showListInPopup}
      disabled={disabled}
      onInputFocusChange={onInputFocusChange}
    />
  );
};

export { TagControls };
